'use strict';

angular.module('docketbook').
  controller('interactionModalController', function($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, accessControl, $timeout, geolocation) {

    $scope.availableInteractions = [];
    $scope.interactionCallback = null;
    $scope.docketEditing = null;
    $scope.formLoading = false

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.newInteractionFromParent = function(docket, resource, cb) {
      $scope.interactionCallback = cb;
      $scope.addInteraction = {};
      $scope.addInteraction.resource = resource.resource;
      $scope.addInteraction.mode = 'selectTemplate';
      $scope.docketEditing = docket;

      $("#addInteractionModal").fadeIn(100);
      $scope.formLoading = false

      $scope.getAvailableInteractions(docket, resource.resource, function(availableInteractions) {
        $scope.availableInteractions = availableInteractions;

        if ( $scope.availableInteractions.length == 1 ) {
          $scope.selectInteractionTemplate($scope.availableInteractions[0]);
        }
      });
    }

    $scope.$parent.editInteractionFromParent = function(docket, interaction, resource, cb) {
      $scope.interactionCallback = cb;
      $scope.docketEditing = docket;
      $scope.addInteraction = {};
      $scope.addInteraction.loading = false;
      $scope.addInteraction.mode = 'detail';
      $scope.addInteraction.resource = resource;
      $scope.addInteraction.interaction = interaction;
      $scope.addInteraction.interactionTemplate = interaction.interactionTemplate;
      $scope.addInteraction.edit = true;
      if ( !$scope.docketEditing.editing || !$scope.userCanDoAction('editDocketInteraction', docket) ) {
        $scope.addInteraction.readOnly = true;
      } else {
        $scope.addInteraction.readOnly = false;
      }

      // if resource is time - convert to abbreviation
      if ( interaction.resource.uom.isTime ) {
        var quantity = interaction.quantity;
        var abbreviation = interaction.resource.uom.abbreviation;
        if ( abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs' ) {
          // display as hours
          interaction.quantityEdit = quantity / 60;
          interaction.quantityEditType = 'h';
        }
        if ( abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins' ) {
          // display as hours and minutes
          var hours = Math.floor(quantity / 60);
          var minutes = quantity % 60;
          interaction.quantityHoursEdit = hours;
          interaction.quantityMinutesEdit = minutes;
          interaction.quantityEditType = 'hm';
        }
        if ( abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins' ) {
          interaction.quantityEdit = quantity;
          interaction.quantityEditType = 'm';
        }
      } else {
        interaction.quantityEdit = interaction.quantity;
      }

      if ( $scope.addInteraction.interaction.interactionTemplate.refersParent == true ) {
        $scope.addInteraction.interaction.resourceIsParent = true;
      }

      $("#addInteractionModal").fadeIn(100);
      $scope.formLoading = false
      $timeout(function() {
        $("#quantityKeypadField").focus();
      },1000);

      // Show map
      if ( $scope.addInteraction.interaction.lat && $scope.addInteraction.interaction.long ) {
        var latLng = { lat: $scope.addInteraction.interaction.lat, lng: $scope.addInteraction.interaction.long };
        var options = {
          //center: new google.maps.LatLng($scope.addInteraction.interaction.latitude, $scope.addInteraction.interaction.longitude),
          center: latLng,
          zoom: 18,
          disableDefaultUI: true
        };

        var marker = new google.maps.Marker({
          position: latLng,
          title: 'Line Created Here',
          animation: google.maps.Animation.DROP
        });

        $timeout(function() {
          var map = new google.maps.Map(document.getElementById('interactionMap'), options);
          var places = new google.maps.places.PlacesService(map);
          marker.setMap(map);
        },1000);
      }
    }

    /*********************************/
    /***** Interaction Functions *****/
    /*********************************/

    $scope.selectInteractionTemplate = function(interactionTemplate) {
      // setup the new interaction
      $scope.addInteraction.interactionTemplate = interactionTemplate;
      $scope.addInteraction.interaction = {};
      $scope.addInteraction.interaction.interactionName = $scope.addInteraction.interactionTemplate.name;
      $scope.addInteraction.interaction.interactionTemplate = $scope.addInteraction.interactionTemplate;
      $scope.addInteraction.interaction.quantityEdit = "";
      $scope.addInteraction.interaction.customFields = {};
      // if the interaction template resource refers parent - set resource to parent
      if ( $scope.addInteraction.interactionTemplate.refersParent == true ) {
        $scope.addInteraction.interaction.resource = $scope.addInteraction.resource;
        $scope.addInteraction.interaction.resourceIsParent = true;
      }
      // setup customFields object store
      if ( $scope.addInteraction.interactionTemplate.customFields != null ) {
        var objectStore = {};
        $scope.addInteraction.interactionTemplate.customFields.forEach(function(item) {
          objectStore[item] = "";
        });
        $scope.addInteraction.interaction.customFields = objectStore;
      }

      // Ensure time values are set to null so that they don't default to the current time
      $scope.addInteraction.interactionTemplate.fields.forEach(field =>{
        if (field.type == 'time') {
          $scope.addInteraction.interaction.customFields[field.id] = null
        }
      })

      if ( !interactionTemplate.refersParent ) {
        // Now get available resources for this interaction
        $scope.addInteraction.availableCategoriesWithResources = $scope.getAvailableResources(interactionTemplate);
      }

      $scope.addInteraction.mode = 'detail';
      $timeout(function() {
        $("#quantityKeypadField").focus();
      },1000);
    }

    $scope.selectResourceForInteraction = function(interaction) {
      $("#addInteractionModal").fadeOut(100);
      $scope.$parent.selectResourceForDocket(interaction.availableCategoriesWithResources, function(resourceSelected) {
        interaction.interaction.resource = resourceSelected;
        $("#addInteractionModal").fadeIn(100);
        $scope.formLoading = false
      });
    }

    $scope.saveInteraction = function(interaction) {
      $scope.formLoading = true
      interaction.quantityEdit = parseFloat(interaction.quantityEdit);

      $scope.interactionCallback(interaction);
      $("#addInteractionModal").fadeOut(100);
    }

    $scope.removeEditingInteraction = function() {
      $scope.addInteraction.delete = true;
      $scope.interactionCallback($scope.addInteraction);
      $("#addInteractionModal").fadeOut(100);
    }

    $scope.closeAddInteraction = function() {
      $scope.interactionCallback(null);
      $("#addInteractionModal").fadeOut(100);
    }

    $scope.getAvailableResources = function(interactionTemplate) {
      var orderResources = [];
      if ( $scope.docketEditing.jobRef ) {
        // docket is from job - use job line items to get resources list
        for ( var i = 0; i < $scope.docketEditing.jobRef.lineItems.length; i++ ) {
          if ( orderResources.indexOf($scope.docketEditing.jobRef.lineItems[i].resource) == -1 ) {
            orderResources.push($scope.docketEditing.jobRef.lineItems[i].resource);
          }
        }
      } else if ( $scope.docketEditing.orderRef ) {
        // docket is from order - use order line items to get resources list
        for ( var i = 0; i < $scope.docketEditing.orderRef.lineItems.length; i++ ) {
          if ( orderResources.indexOf($scope.docketEditing.orderRef.lineItems[i].resource) == -1 ) {
            orderResources.push($scope.docketEditing.orderRef.lineItems[i].resource);
          }
        }
      }

      if ( !interactionTemplate.childFromOrder ) {
        // child resources do not have to be from order - set to all from order/job
        orderResources = $scope.allResources;
      }

      // go over categories and group available resources by category
      var availableCategoriesWithResources = [];
      var templateCategories = $scope.addInteraction.interactionTemplate.categories;
      for ( var i = 0; i < templateCategories.length; i++ ) {
        // get all resources for this categories (from orderResources list - already sorted by order/job)
        var categoryResources = [];
        for ( var j = 0; j < orderResources.length; j++ ) {
          if ( orderResources[j].categoryId == templateCategories[i].id ) {
            categoryResources.push(orderResources[j]);
          }
        }
        templateCategories[i].resources = categoryResources;
        availableCategoriesWithResources.push(templateCategories[i]);
      }

      return availableCategoriesWithResources;
    }

    $scope.getAvailableInteractions = function(docket, resource, cb) {
      var interactionTemplates = [];
      for ( var i = 0; i < docket.template.interactionTemplates.length; i++ ) {
        var currentInteractionTemplate = docket.template.interactionTemplates[i];
        // check if interactionTemplate/actorCategories contains this category id
        for ( var j = 0; j < currentInteractionTemplate.actorCategories.length; j++ ) {
          if ( currentInteractionTemplate.actorCategories[j].id == resource.categoryId ) {
            interactionTemplates.push(currentInteractionTemplate);
            break;
          }
        }
      }
      cb(interactionTemplates);
    }

    /***************************************/
    /***** Quantity Edit Functionality *****/
    /***************************************/

    // Mobile only - edit line item quantity
    $scope.editInteractionQuantity = function(addInteraction) {
      $("#addInteractionModal").fadeOut(100);
      //$("#quantityKeypadModal").fadeIn(100);
      $scope.quantityKeypadValue = angular.copy(addInteraction.interaction.quantityEdit);
      $scope.quantityEditObject = addInteraction.interaction;
      $scope.quantityEditFieldName = 'quantityEdit';
      $scope.quantityKeypadUom = addInteraction.interaction.resource.uom;
    }

    $scope.closeQuantityEditModal = function() {
      //$("#quantityKeypadModal").fadeOut(100);
      $("#addInteractionModal").fadeIn(100);
    }

    $scope.saveQuantityEdit = function() {
      var newValueFloat = parseFloat($scope.quantityKeypadValue);
      $scope.quantityEditObject[$scope.quantityEditFieldName] = newValueFloat;
      $scope.closeQuantityEditModal();
    }

    $scope.keypadButtonPress = function(buttonValue) {
      if ( $scope.quantityKeypadValue == null ) {
        $scope.quantityKeypadValue = 0;
      }

      var currentValString = $scope.quantityKeypadValue.toString();

      if ( buttonValue == '.' ) {
        currentValString += ".";
      } else if ( buttonValue == 'back' ) {
        if ( currentValString.length > 1 ) {
          currentValString = currentValString.substring(0, currentValString.length - 1);
        } else if ( currentValString.length == 1 ) {
          currentValString = "0";
        }
      } else {
        if ( currentValString == "0" ) {
          currentValString = buttonValue.toString();
        } else {
          currentValString += buttonValue.toString();
        }
      }

      $scope.quantityKeypadValue = currentValString;
    }
});



// WEBPACK FOOTER //
// ./src/controllers/modals/interactionModalController.js